import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { class: "p-field-label" }
const _hoisted_3 = { class: "p-field-checkbox" }
const _hoisted_4 = { for: "isManagePosition" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.ManagePosition")), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Checkbox, {
        id: "isManagePosition",
        name: "isManagePosition",
        modelValue: _ctx.roomObject.isManagePosition,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roomObject.isManagePosition = $event)),
        binary: true
      }, null, 8, ["modelValue"]),
      _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.ManagePosition")), 1)
    ])
  ]))
}